import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import InfiniteScroll from 'react-infinite-scroll-component';
import useFilters from '../../hooks/useFilters';
import { useAppSelector } from '../../store/reducers';
import { saveFilteredJockeys } from '../../store/reducers/Stable/jockeys';
import { jockeyFilterConfig } from '../../views/RaceStableList/JockeyFilters/jockeyFilterConfig';
import Loader from '../Loader/Loader';
import Paragraph from '../Typography/Paragraph/Paragraph';
import styles from './JockeyCard.module.scss';
import JockeyItem from './JockeyItem/JockeyItem';
const JockeysCard = () => {
    const { t } = useTranslation();
    const pending = useAppSelector((state) => state.jockeys.pending);
    const jockeys = useAppSelector((state) => state.jockeys.jockeys);
    const isConnected = useAppSelector((state) => state.wallet.activeWallet.isConnected);
    const [limit, setLimit] = useState(10);
    const filteredJockeys = useFilters(jockeys, jockeyFilterConfig, saveFilteredJockeys);
    const jockeyItems = useMemo(() => filteredJockeys &&
        filteredJockeys.map((item, index) => (_jsx(JockeyItem, { data: item, index: index }, item.asset.assetName))), [filteredJockeys]);
    const jockeyList = jockeyItems ? (_jsx(InfiniteScroll, Object.assign({ next: () => setLimit(limit + 10), hasMore: limit < jockeyItems.length, loader: null, dataLength: limit }, { children: jockeyItems === null || jockeyItems === void 0 ? void 0 : jockeyItems.slice(0, limit) }))) : null;
    const content = (jockeyItems === null || jockeyItems === void 0 ? void 0 : jockeyItems.length) ? (jockeyList) : (_jsx(Paragraph, { title: t('no_results'), className: styles.noResult }));
    return (_jsx("div", Object.assign({ className: styles.list }, { children: pending || !isConnected ? (_jsx(Loader, { isTransparent: true, className: cn('d-flex align-items-start', styles.loader) })) : (content) })));
};
export default JockeysCard;
